import { backendBaseUrl } from "./config/api";

let API_BASE = backendBaseUrl();
if (typeof window !== "undefined" && window.location.hostname === "localhost" && window.location.port === "3000") {
  API_BASE = "http://localhost/Ashoka/backend";
}

export async function fetchGaMeasurementId() {
  const url = `${API_BASE}/ga.php`;
  const res = await fetch(url, { credentials: "include", headers: { Accept: "application/json" } });
  const ct = res.headers.get("content-type") || "";
  const data = ct.includes("application/json") ? await res.json().catch(() => ({})) : {};
  if (!res.ok || data.success === false) {
    throw new Error(data.message || "Unable to load GA settings");
  }
  return data.measurement_id || "";
}
